import spinner from "../../../assets/loading-spinner.gif";
import styles from "./LoadingIndicator.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var LoadingIndicator = function LoadingIndicator(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 100 : _ref$size;
  return /*#__PURE__*/_jsx("div", {
    className: styles.spinner,
    children: /*#__PURE__*/_jsx("div", {
      style: {
        height: "".concat(size, "px"),
        width: "".concat(size, "px"),
        backgroundImage: "url(".concat(spinner, ")"),
        backgroundSize: 'contain'
      }
    })
  });
};